import api from './api';
import practiceService from './practiceService';

// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

// // Create axios instance with default config
// const api = axios.create({
//   baseURL: API_URL,
//   withCredentials: true,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

const careManagementService = {
  // Get follow-up query results
  getFollowUpQuery: async (filters = {}) => {
    const response = await api.get('/care-management/follow-up-query', { params: filters });
    return response;
  },

  // Get dropdown options for follow-up query (optional endpoint)
  getFollowUpQueryOptions: async () => {
    try {
      const response = await api.get('/care-management/follow-up-query/options');
      return response;
    } catch (error) {
      // Return a mock response if endpoint doesn't exist (404)
      if (error.response?.status === 404) {
        return {
          data: {
            success: false,
            data: {}
          }
        };
      }
      throw error;
    }
  },

  // Export follow-up query results
  exportFollowUpQuery: async (filters = {}, format = 'csv') => {
    const response = await api.get('/care-management/follow-up-query/export', {
      params: { ...filters, format },
      responseType: format === 'csv' ? 'blob' : 'blob'
    });
    return response;
  },

  // Email follow-up query results
  emailFollowUpQuery: async (filters = {}, emailData) => {
    // If emailData has attachments, use FormData
    if (emailData.attachments && emailData.attachments.length > 0) {
      const formData = new FormData();
      formData.append('filters', JSON.stringify(filters));
      Object.keys(emailData).forEach(key => {
        if (key !== 'attachments') {
          formData.append(key, emailData[key]);
        }
      });
      emailData.attachments.forEach((file) => {
        formData.append('attachments', file);
      });

      const response = await api.post('/care-management/follow-up-query/email', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response;
    } else {
      const response = await api.post('/care-management/follow-up-query/email', {
        filters,
        ...emailData
      });
      return response;
    }
  },

  // Add follow-up note (from query page)
  addFollowUp: async (practiceId, patientId, followUpData) => {
    const response = await api.post(`/practices/${practiceId}/patients/${patientId}/follow-ups`, followUpData);
    practiceService.invalidatePracticePatientCaches(practiceId);
    return response;
  }
};

export default careManagementService;

